import { Navigate, useLocation, useParams } from 'react-router-dom';

function canonicalTutoringHash(hash: string): string {
  if (hash === '#teacher-directory') return '#tutors';
  if (hash === '#private-tutoring') return '#request';
  return hash;
}

export function LegacyTeachersRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: '/portal/tutoring',
        search: location.search,
        hash: canonicalTutoringHash(location.hash),
      }}
      replace
    />
  );
}

export function LegacyTeacherProfileRedirect() {
  const location = useLocation();
  const { slug = '' } = useParams();
  return (
    <Navigate
      to={{
        pathname: `/portal/tutoring/${encodeURIComponent(slug)}`,
        search: location.search,
        hash: canonicalTutoringHash(location.hash),
      }}
      replace
    />
  );
}
